import React from "react";
import { defineMessages } from "react-intl";
import { WideSplitView } from "cci-component";
import { PrimaryPage, ReportPreview } from "cci-admin";
import Options from "../report/inventoryOnHand/Options";

const messages = defineMessages({
  selectReportOptions: {
    id: "selectReportOptions",
    defaultMessage: "Select the desired options to preview or print the report."
  }
});

/**
 * Inventory On-Hand Reports Page.
 */
const InventoryOnHandReportPage = () => (
  <PrimaryPage>
    <WideSplitView
      rootPath="/inventoryonhandreport"
      selectionPath="/inventoryonhandreport/preview/:options"
      left={Options}
      right={ReportPreview}
      leftRightOptions={{
        reportName: "prs/data/report/inventoryOnHand.rptdesign"
      }}
      leftOptions={{ previewPath: "/inventoryonhandreport" }}
      placeholderMessage={messages.selectReportOptions}
    />
  </PrimaryPage>
);

export default InventoryOnHandReportPage;
